import { Mail, MapPin, Phone } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { scrollToId } from "../../lib/scroll";

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === "/";

const nav = (e, id) => { 
  e.preventDefault();
    if (!isHome) {
      navigate("/");
      setTimeout(() => scrollToId(id), 120);
    } else {
  scrollToId(id);
    }
};

  const goCatalogue = (e) => {
    e.preventDefault();
    navigate("/catalogue");
    window.scrollTo({ top: 0 });
  };

  return (
  <footer data-testid="site-footer" className="bg-[#2A221C] text-[#FDFBF7]">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <p className="font-display text-5xl md:text-7xl leading-none">
            Artisan<span className="text-[#D4A373]"> Bites</span>
          </p>
          <p className="mt-6 font-light text-[#FDFBF7]/60 max-w-sm leading-relaxed">
            Premium products. Built for service. Supplying hotels, restaurants and cafés
            with desserts worth remembering.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-[10px] tracking-[0.25em] uppercase text-[#D4A373] mb-5">Contact</p>
          <ul className="space-y-4 text-sm text-[#FDFBF7]/75">
            <li className="flex items-start gap-3"><Phone className="h-4 w-4 mt-0.5 text-[#D4A373]" /><a href="tel:+971553289793"> +971 55 328 9793</a></li>
            <li className="flex items-start gap-3"><Mail className="h-4 w-4 mt-0.5 text-[#D4A373]" /><a href="mailto:info@artisanbites.com"> info@artisanbites.com></a></li>
            <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 text-[#D4A373]" /> Saih Shuaib 3, Dubai, UAE </li>

          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-[10px] tracking-[0.25em] uppercase text-[#D4A373] mb-5">Explore</p>
          <ul className="space-y-4 text-sm text-[#FDFBF7]/75">
              <li>
                <a href="#menu" onClick={(e) => nav(e, "#menu")} className="hover:text-[#D4A373] transition-colors">
                  The Collection
                </a>
              </li>
              <li>
                <a href="/catalogue" onClick={goCatalogue} className="hover:text-[#D4A373] transition-colors">
                  Full HORECA Catalogue
                </a>
              </li>
              <li>
                <a href="#manifesto" onClick={(e) => nav(e, "#manifesto")} className="hover:text-[#D4A373] transition-colors">
                  How We Work
                </a>
              </li>
              <li>
                <a href="#enquire" onClick={(e) => nav(e, "#enquire")} className="hover:text-[#D4A373] transition-colors">
                  Request Samples
                </a>
              </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#FDFBF7]/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#FDFBF7]/40">
        <span>© {new Date().getFullYear()} Artisan Bites. All rights reserved.</span>
        <span className="tracking-[0.2em] uppercase">Artisanal · Handcrafted · Premium</span>
      </div>
    </div>
  </footer>
);
};
